import styled from "styled-components";
import { dispositivo } from "../../components/Dispositivos";

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100%;
  width: 100%;

  @media ${dispositivo.tablet} {
    padding: 3rem;
  }
`;

export const ProfileCard = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
`;

export const ProfileHeader = styled.div`
  background: linear-gradient(135deg, #0C234C 0%, #0c8de3 100%);
  padding: 3rem 2rem;
  color: white;
  text-align: center;
  position: relative;
`;

export const ProfileAvatarWrapper = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: white;
  padding: 5px;
  margin: 0 auto 1.5rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  svg {
    font-size: 60px;
    color: #0c8de3;
  }
`;

export const ProfileName = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.5px;
`;

export const ProfileRole = styled.div`
  display: inline-block;
  padding: 0.4rem 1.2rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  font-size: 0.9rem;
  margin-top: 0.8rem;
  font-weight: 500;
  backdrop-filter: blur(5px);
`;

export const ProfileContent = styled.div`
  padding: 2.5rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  @media ${dispositivo.tablet} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const InfoGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const InfoLabel = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const InfoValue = styled.span`
  font-size: 1.1rem;
  font-weight: 500;
  color: #0C234C;
  border-bottom: 2px solid #67D2DC30;
  padding-bottom: 0.5rem;
`;

export const ProfileFooter = styled.div`
  padding: 2rem;
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
`;

export const CalendarButton = styled.button`
  background: #0c8de3;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  box-shadow: 0 4px 12px rgba(12, 141, 227, 0.3);

  &:hover {
    background: #0a7cc8;
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(12, 141, 227, 0.4);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

// Legacy components for backward compatibility during transition if needed
export const RegistroWrapper = styled.div`
  display: block;
  width: 100%;
  height: 100%;
`;
export const ContainerTitle = styled.div``;
export const ContainerTitleText = styled.h2``;
export const ContainerLeft = styled.div``;
export const StyledButton = styled.button``;
export const StyledLabel = styled.label``;
export const DivInput = styled.div``;
export const StyledInput = styled.input``;
export const RegistroFormWrapper = styled.section``;
export const StyledForm = styled.div``;